import { Banner } from '../../types'

export function bannerFixture({ campaignBannerMessage = '' } = {}): Banner {
  return {
    campaignBannerMessage
  }
}
